module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.scss
// module id = ./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates.component.scss
// module chunks = 0